export default __webpack_public_path__ + "static/media/Skoda_LOISTO_tunnus_RGB_musta.d5e70670.png";